/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Home_LabelInputs */

const da_app_home_label = /** @type {(inputs: App_Home_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AImforA - forside`)
};

/** @type {(inputs: App_Home_LabelInputs) => LocalizedString} */
const en_app_home_label = da_app_home_label;

/**

* @param {App_Home_LabelInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const app_home_label = /** @type {((inputs?: App_Home_LabelInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Home_LabelInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_app_home_label(inputs)
	return /** @type {LocalizedString} */ ("AImforA - forside")
});